import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthProvider';
import { AuthGuard } from '@/auth/AuthGuard';
import { LoginPage } from '@/auth/loginPage';
import { SignupPage } from '@/auth/SignupPage';
import { ForgotPasswordPage } from '@/auth/ForgotPasswordPage';
import { ResetPasswordPage } from '@/auth/ResetPasswordPage';
import { AcceptInvitePage } from '@/pages/AcceptInvitePage';
import { AppShell } from '@/components/layout/AppShell';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';

const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then((m) => ({ default: m.DashboardPage }))
);
const GeofencePage = lazy(() =>
  import('@/pages/GeofencePage').then((m) => ({ default: m.GeofencePage }))
);
const OrganizationSettingsPage = lazy(() =>
  import('@/pages/OrganizationSettingsPage').then((m) => ({
    default: m.OrganizationSettingsPage,
  }))
);
const OrganizationsPage = lazy(() =>
  import('@/pages/OrganizationsPage').then((m) => ({
    default: m.OrganizationsPage,
  }))
);


function SuspenseWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="flex h-full items-center justify-center">
          <LoadingSpinner />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />

          <Route
            element={
              <AuthGuard>
                <AppShell showSidebar={true} />
              </AuthGuard>
            }
          >
            <Route
              index
              element={
                <SuspenseWrapper>
                  <DashboardPage />
                </SuspenseWrapper>
              }
            />
          </Route>

          <Route
            element={
              <AuthGuard>
                <AppShell showSidebar={false} />
              </AuthGuard>
            }
          >
            <Route
              path="boundaries"
              element={
                <SuspenseWrapper>
                  <GeofencePage />
                </SuspenseWrapper>
              }
            />
            <Route
              path="organization"
              element={
                <SuspenseWrapper>
                  <OrganizationSettingsPage />
                </SuspenseWrapper>
              }
            />
            <Route
              path="organization/:id"
              element={
                <SuspenseWrapper>
                  <OrganizationSettingsPage />
                </SuspenseWrapper>
              }
            />
            <Route
              path="organizations"
              element={
                <SuspenseWrapper>
                  <OrganizationsPage />
                </SuspenseWrapper>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
